import React from 'react';
import ReactDOM from 'react-dom';
import { useAuth } from 'api';
import { BrowserRouter as Router, Redirect, Switch, Route } from "react-router-dom";
import { Loading } from 'ui';
import Navigation from './Navigation';
import Auth from './Auth';
import Dashboard from './Dashboard';
import Companies from './Companies';
import Users from './Users';
import Pages from './Pages';
import Media from './Media';
import Campaigns from './Campaigns';
import Tags from './Tags';
import Preview from './Preview';
import Reports from './Reports';
import TOS from './TOS';
import Help from './Help';
import "@fortawesome/fontawesome-pro/css/all.min.css";

function App() {
  return (
    <Router>
      <Route render={({location}) => 
        location.pathname.indexOf('auth') > -1 ? null : 
        location.pathname.indexOf('preview') > -1 ? null :
        <Navigation/>
      }/>
      <Switch>
        <Route path="/auth"><Auth/></Route>
        <PrivateRoute path="/preview"><Preview/></PrivateRoute>
        <PrivateRoute path="/dashboard"><Dashboard/></PrivateRoute>
        <PrivateRoute path="/campaigns"><Campaigns/></PrivateRoute>
        <PrivateRoute path="/tags"><Tags/></PrivateRoute>
        <PrivateRoute path="/pages"><Pages/></PrivateRoute>
        <PrivateRoute path="/media"><Media/></PrivateRoute>
        <PrivateRoute path="/companies"><Companies/></PrivateRoute>
        <PrivateRoute path="/users"><Users/></PrivateRoute>
        <PrivateRoute path="/tos"><TOS/></PrivateRoute>
        <PrivateRoute path="/help"><Help/></PrivateRoute>
        <PrivateRoute path="/reports/:campaignId?"><Reports/></PrivateRoute>
        <Redirect to="/dashboard"/>
      </Switch>
    </Router>
  );
}

function PrivateRoute({ children, ...rest }) {
  const auth = useAuth();
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if(auth === null) {
          return <Loading/>;
        }
        if(!auth.uid) {
          return <Redirect to="/auth"/>;
        }
        if(!auth.emailVerified) {
          return <Redirect to="/auth/verify-email"/>;
        }
        if(!auth.company.plan) {
          return <Redirect to="/auth/plan"/>;
        }
        if(!auth.company.name) {
          return <Redirect to="/auth/company"/>;
        }
        if(!auth.company.subscriptionId) {
          return <Redirect to="/auth/billing"/>;
        }
        return children;
      }}
    />
  );
}

const el = document.getElementById("root");
ReactDOM.render(<App/>, el);